import React from 'react';
// Wall materials
import wallSmoothMatte from './material-textures/wall-smooth-matte.webp';
import wallVenetian from './material-textures/wall-venetian-plaster.webp';
import wallLimewash from './material-textures/wall-limewash.webp';
import wallTadelakt from './material-textures/wall-tadelakt.webp';
import wallConcreteSmooth from './material-textures/wall-concrete-smooth.webp';
import wallMicrocement from './material-textures/wall-microcement.webp';
// Floor materials
import floorPolishedConcrete from './material-textures/floor-polished-concrete.webp';
import floorMatteMicrocement from './material-textures/floor-matte-microcement.webp';
import floorPaleHardwood from './material-textures/floor-pale-hardwood.webp';
import floorWhiteMarble from './material-textures/floor-white-marble.webp';
import floorLightPorcelain from './material-textures/floor-light-porcelain.webp';
import floorGlossyResin from './material-textures/floor-glossy-resin.webp';

/**
 * Wall / floor material thumbnails — pre-generated seamless texture tiles
 * (tiny WebP), keyed by the recipe option value. Used by the Sunlit-empty-room
 * preset's Wall material / Floor material selects.
 */

export const WALL_MATERIAL_TEXTURES: Record<string, string> = {
    'smooth-matte': wallSmoothMatte,
    'venetian-plaster': wallVenetian,
    'limewash': wallLimewash,
    'tadelakt': wallTadelakt,
    'concrete-smooth': wallConcreteSmooth,
    'microcement': wallMicrocement,
};

export const FLOOR_MATERIAL_TEXTURES: Record<string, string> = {
    'polished-concrete': floorPolishedConcrete,
    'matte-microcement': floorMatteMicrocement,
    'pale-hardwood': floorPaleHardwood,
    'white-marble': floorWhiteMarble,
    'light-porcelain': floorLightPorcelain,
    'glossy-resin': floorGlossyResin,
};

const baseStyle: React.CSSProperties = {
    width: '100%',
    aspectRatio: '4/3',
    display: 'block',
    borderRadius: 6,
};

/** Renders a material texture tile as a 4:3 card. */
export const MaterialTextureSwatch: React.FC<{ src?: string }> = ({ src }) => (
    <div
        style={{
            ...baseStyle,
            ...(src
                ? { backgroundImage: `url(${src})`, backgroundSize: 'cover', backgroundPosition: 'center' }
                : { background: 'linear-gradient(180deg, #F1EFEA 0%, #E2DED5 100%)' }),
            border: '1px solid rgba(0,0,0,0.08)',
            boxShadow: 'inset 0 1px 2px rgba(255,255,255,0.2)',
        }}
    />
);
